// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lr-mar-mob4-desk24 {
    margin-right: 24px;
    margin-left: 24px;
}
.tb-mar-mob0-desk48 {
    margin-top: 5%;
    margin-bottom: 5%;
}

@media screen and (max-width: 999px) {
    .lr-mar-mob4-desk24 {
        margin-right: 4px;
        margin-left: 4px;
    }
    .tb-mar-mob0-desk48 {
        margin-top: 0px;
        margin-bottom: 0px;
    }
}

.cp{padding:30px;box-shadow: 0px 0px 20px 0px #b6b6b6;}

.loginshadow {
    box-shadow: 1px 0px 4px 0px;
}

.form-control:focus {
    color: #212529;
    background-color: #fff;
    border-color: #db243a52;
    outline: 0;
    box-shadow: 0 0 0 0.25rem rgb(219 36 58 / 0%);
}

`, "",{"version":3,"sources":["webpack://./src/modules/user/login.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI;QACI,iBAAiB;QACjB,gBAAgB;IACpB;IACA;QACI,eAAe;QACf,kBAAkB;IACtB;AACJ;;AAEA,IAAI,YAAY,CAAC,oCAAoC,CAAC;;AAEtD;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;IACV,6CAA6C;AACjD","sourcesContent":[".lr-mar-mob4-desk24 {\n    margin-right: 24px;\n    margin-left: 24px;\n}\n.tb-mar-mob0-desk48 {\n    margin-top: 5%;\n    margin-bottom: 5%;\n}\n\n@media screen and (max-width: 999px) {\n    .lr-mar-mob4-desk24 {\n        margin-right: 4px;\n        margin-left: 4px;\n    }\n    .tb-mar-mob0-desk48 {\n        margin-top: 0px;\n        margin-bottom: 0px;\n    }\n}\n\n.cp{padding:30px;box-shadow: 0px 0px 20px 0px #b6b6b6;}\n\n.loginshadow {\n    box-shadow: 1px 0px 4px 0px;\n}\n\n.form-control:focus {\n    color: #212529;\n    background-color: #fff;\n    border-color: #db243a52;\n    outline: 0;\n    box-shadow: 0 0 0 0.25rem rgb(219 36 58 / 0%);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
